<button
  class="toggle-button"
  tabindex="0"
  [disabled]="disabled"
  [class.active]="active"
  [class.disabled]="disabled"
  [attr.aria-pressed]="active"
  (click)="onClick.emit($event)"
>
  {{ label }}
</button>
